import { render, staticRenderFns } from "./datasc.vue?vue&type=template&id=41a5a62a&scoped=true&"
import script from "./datasc.vue?vue&type=script&lang=js&"
export * from "./datasc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a5a62a",
  null
  
)

export default component.exports